import { render, staticRenderFns } from "./MobileTreinamentoComponent.vue?vue&type=template&id=8148d468&lang=pug&"
var script = {}
import style0 from "./MobileTreinamentoComponent.vue?vue&type=style&index=0&id=8148d468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports